import type { VariantProps } from "class-variance-authority";
import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
import { inputVariants } from "./Input";

export interface TextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement>,
    VariantProps<typeof inputVariants> {}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      className,
      accent,
      surface,
      borderWeight,
      inputSize,
      mono,
      ...props
    },
    ref,
  ) => (
    <textarea
      className={cn(
        inputVariants({ accent, surface, borderWeight, inputSize, mono }),
        "resize-none",
        className,
      )}
      ref={ref}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";
